






















import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class AButton extends Vue {
  @Prop({ required: true, type: String })
  loadingLabel!: string;

  @Prop({ required: false, type: String })
  doneLabel!: string;

  @Prop({ required: true, type: Boolean })
  isLoading!: boolean;

  @Prop({ required: false, type: Boolean, default: () => false })
  isDone!: boolean;
}
